import axios from "axios";
import { bloqueadoEnDemo, MSG_DEMO } from "../../utils/demo";
// La URL de la API se resuelve en RUNTIME, no en el build: config.js lo escribe
// el contenedor desde el .env, asi la misma imagen sirve dev y prod. El fallback
// a process.env mantiene andando 'npm start' en la maquina local.
const BASE_URL =
    (window.__CONFIG__ && window.__CONFIG__.apiUrl) || process.env.REACT_APP_BACKEND_URL;

export const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Refresh-Sent": "false",
    }
})

const sendRequest = async (method, uri, params = {}, signal) => {
    // Misma forma que los errores del back, para que los catch existentes muestren el mensaje.
    // eslint-disable-next-line no-throw-literal
    if (bloqueadoEnDemo(method, uri)) throw { status: 403, message: MSG_DEMO }

    switch (method) {
        case "POST": {
            return await axiosInstance.post(uri, { ...params }, { signal })
        }

        case "GET": {
            return await axiosInstance.get(uri, { params, signal })
        }

        case "PATCH": {
            return await axiosInstance.patch(uri, { ...params }, { signal })
        }

        case "DELETE": {
            return await axiosInstance.delete(uri, {}, { signal })
        }

        default: {
            throw new Error("Falta method del fetch")
        }
    }
}

export const requestService = {
    sendRequest
}